import { render } from "./AppDataTableElt.vue?vue&type=template&id=6d0ccab9&scoped=true"
import script from "./AppDataTableElt.vue?vue&type=script&lang=js"
export * from "./AppDataTableElt.vue?vue&type=script&lang=js"

import "./AppDataTableElt.vue?vue&type=style&index=0&id=6d0ccab9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0ccab9"]])

export default __exports__